import gql from "graphql-tag";

export const MY_TIMESHEET_UPDATE_PROJECT = gql`
  mutation updateMySheetProject(
    $_id: String!
    $name: String!
    $color: String
    $description: String!
    $validFrom: Date
    $validTo: Date
  ) {
    updateMySheetProject(
      _id: $_id
      name: $name
      color: $color
      description: $description
      validFrom: $validFrom
      validTo: $validTo
    ) {
      _id
      name
      description
      color
      validFrom
      validTo
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      isDeleted
    }
  }
`;
